import { render } from "./PurchaseTable.vue?vue&type=template&id=66eef363&scoped=true"
import script from "./PurchaseTable.vue?vue&type=script&lang=js"
export * from "./PurchaseTable.vue?vue&type=script&lang=js"

import "./PurchaseTable.vue?vue&type=style&index=0&id=66eef363&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66eef363"]])

export default __exports__